"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteEligibilityRuleSchema = exports.duplicateEligibilityRuleSchema = exports.toggleEligibilityRuleSchema = exports.updateEligibilityRuleSchema = exports.createEligibilityRuleSchema = void 0;
const zod_1 = require("zod");
const rule_schema_1 = require("../eligibility/rule-schema");
const financing_1 = require("../financing");
const changeNoteSchema = zod_1.z.string().trim().min(1);
const expectedVersionSchema = zod_1.z.number().int().min(0);
exports.createEligibilityRuleSchema = zod_1.z
    .object({
    partner: financing_1.financingPartnerSchema,
    change_note: changeNoteSchema,
    rule: rule_schema_1.eligibilityRuleInputSchema,
})
    .strict();
exports.updateEligibilityRuleSchema = zod_1.z
    .object({
    change_note: changeNoteSchema,
    expected_version: expectedVersionSchema,
    rule: rule_schema_1.eligibilityRuleInputSchema,
})
    .strict();
// is_enabled is an explicit target, not a flip. A flip would double-invert on a retry; an explicit target is idempotent.
exports.toggleEligibilityRuleSchema = zod_1.z
    .object({
    is_enabled: zod_1.z.boolean(),
    change_note: changeNoteSchema,
    expected_version: expectedVersionSchema,
})
    .strict();
exports.duplicateEligibilityRuleSchema = zod_1.z
    .object({
    target_partner: financing_1.financingPartnerSchema.optional(),
    change_note: changeNoteSchema,
    expected_version: expectedVersionSchema,
})
    .strict();
exports.deleteEligibilityRuleSchema = zod_1.z
    .object({
    change_note: changeNoteSchema,
    expected_version: expectedVersionSchema,
})
    .strict();
//# sourceMappingURL=eligibility-rules.js.map